import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SubProfessionalCategoryComponent } from './sub-professional-category.component';

const routes: Routes = [
  {
    path: '',component: SubProfessionalCategoryComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubProfessionalCategoryRoutingModule { }
